import React, { useRef, useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import SERVICES from "../data/services.data";
import "../styles/OurServices.css";

const services = [
  {
    icon: "fa-solid fa-droplet",
    title: "Hematology Tests",
    description:
      "Complete blood count, ESR, platelet analysis and blood disorder screening.",
    blood: true,
  },
  {
    icon: "fa-solid fa-vial",
    title: "Urine Analysis",
    description:
      "Routine urine examination, infection detection and kidney health assessment.",
  },
  {
    icon: "fa-solid fa-flask-vial",
    title: "Biochemistry Tests",
    description:
      "Blood sugar, liver function, kidney function and lipid profile evaluation.",
  },
  {
    icon: "fa-solid fa-virus",
    title: "Serology Tests",
    description:
      "Dengue, HIV, Hepatitis, Typhoid and other infectious disease screening.",
  },
  {
    icon: "fa-solid fa-dna",
    title: "Hormone Tests",
    description:
      "Thyroid profile, reproductive hormones, Vitamin D and Vitamin B12 testing.",
  },
  {
    icon: "fa-solid fa-bacteria",
    title: "Microbiology Tests",
    description:
      "Culture and sensitivity studies for bacterial, fungal and viral infections.",
  },
  {
    icon: "fa-solid fa-ribbon",
    title: "Cancer Screening",
    description:
      "Tumor marker analysis including PSA, AFP, CA-125 and other diagnostics.",
  },
];

const OurServices = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const handleViewTests = (e, slug) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(`/tests/${slug}`);
  };

  return (
    <section className="services-section" ref={sectionRef}>
      <Container fluid="xxl">

        {/* ── HEADER — same slide-up pattern as HealthPackages ── */}
        <div className="services-header">
          <span
            className={`services-subtitle os-anim-up ${visible ? "os-anim-in" : ""}`}
            style={{ transitionDelay: "0s" }}
          >
            OUR SERVICES
          </span>

          <h2
            className={`services-title os-anim-up ${visible ? "os-anim-in" : ""}`}
            style={{ transitionDelay: "0.12s" }}
          >
            Comprehensive Diagnostic Solutions
          </h2>

          <p
            className={`services-description os-anim-up ${visible ? "os-anim-in" : ""}`}
            style={{ transitionDelay: "0.22s" }}
          >
            Advanced laboratory diagnostics with precision,
            reliability and professional healthcare expertise.
          </p>
        </div>

        {/* ── GRID — cards use slow scale-fade animation ── */}
        <div className="services-grid">
          {services.map((service, index) => (
            <div
              key={index}
              className={`service-card ${service.blood ? "blood-card" : ""} os-anim-scale ${visible ? "os-anim-in" : ""}`}
              style={{ transitionDelay: `${0.32 + index * 0.08}s` }}
            >
              <div className="service-card-top">
                <i
                  className={`${service.icon} ${service.blood ? "blood-icon" : ""}`}
                ></i>
              </div>

              <h4 className="service-title">{service.title}</h4>

              <p className="service-text">{service.description}</p>
              <a
                href={`/tests/${SERVICES[index]?.slug ?? ""}`}
                className="service-link"
                onClick={(e) => handleViewTests(e, SERVICES[index]?.slug)}
              >
                View Tests
                <i className="fa-solid fa-arrow-right ms-2"></i>
              </a>
            </div>
          ))}
        </div>

      </Container>
    </section>
  );
};

export default OurServices;